import React, { useState } from "react";
import { PRICING, MODULE_ORDER } from "../data/pricing";
import PricingCard from "../components/PricingCard";

const PricingTabs = () => {
  const [active, setActive] = useState(MODULE_ORDER[0]);
  const moduleData = PRICING[active];
  const tiers = moduleData?.tiers || [];
  const colsClass = tiers.length === 2 ? "cols-2" : tiers.length === 3 ? "cols-3" : "";

  return (
    <section className="mk-section soft" id="tarifs" data-testid="section-pricing">
      <div className="mk-wrap">
        <div className="mk-section-head mk-reveal">
          <div>
            <h2>Des offres modulaires pour démarrer vite, puis scaler.</h2>
          </div>
        </div>

        <div className="mk-pricing-tabs mk-reveal" role="tablist" aria-label="Tarifs par module">
          {MODULE_ORDER.map((key) => (
            <button
              key={key}
              role="tab"
              type="button"
              aria-selected={active === key}
              className={`mk-pricing-tab${active === key ? " active" : ""}`}
              onClick={() => setActive(key)}
              data-testid={`pricing-tab-${key}`}
            >
              {PRICING[key].label}
            </button>
          ))}
        </div>

        <div
          className={`mk-pricing-grid ${colsClass}`}
          data-testid="pricing-grid"
          data-active-module={active}
          role="tabpanel"
        >
          {tiers.map((tier) => (
            <PricingCard
              key={`${active}-${tier.key}`}
              moduleKey={active}
              moduleLabel={moduleData.label}
              tier={tier}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingTabs;
